<template>
  <div class="light-theme">
    <router-view></router-view>
    <TaskCenter />
    <!-- ICP 备案号页脚。需求来源：《互联网信息服务管理办法》第十二条要求主页显著位置标明备案编号；
         处罚依据见《非经营性互联网信息服务备案管理办法》第二十五条（未在备案编号下方链接备案系统网址，责令改正并处五千至一万元罚款）。
         H5 / 家长端 / 分享页是全屏沉浸式页面，不展示。 -->
    <footer v-if="showIcpFooter" class="icp-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">陕ICP备2025083770号</a>
    </footer>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import TaskCenter from '@/components/TaskCenter.vue'

const route = useRoute()

// 全屏沉浸式页面（家长端、H5 报告、问卷填写、视频分享）不显示备案页脚
const HIDE_FOOTER_PATTERNS = ['/parent', '/h5/', '/s/', '/v/', '/fv/', '/signup/']
const showIcpFooter = computed(
  () => !HIDE_FOOTER_PATTERNS.some((prefix) => route.path.startsWith(prefix))
)

onMounted(() => {
  document.documentElement.setAttribute('data-theme', 'light')
  // 页面模板里有一份静态备案页脚（index.html / public/index.html 的 #icp-fallback），
  // 用于 JS 未执行时兜底；挂载后隐藏它，避免和上面的页脚重复展示。
  // 依赖顺序：本文件是入口组件，一定先于用户访问的页面组件挂载。
  const fallback = document.getElementById('icp-fallback')
  if (fallback) fallback.style.display = 'none'
})
</script>

<style>
.light-theme {
  color-scheme: light;
}

.icp-footer {
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  text-align: center;
  font-size: 12px;
  line-height: 1.6;
  color: #8a8a8e;
}

.icp-footer a {
  color: inherit;
  text-decoration: none;
}

.icp-footer a:hover {
  color: #006edb;
  text-decoration: underline;
}


/* 统一LaTeX公式和文字大小 */
.katex,
.katex-html,
.katex-display,
mjx-container,
.MathJax,
.MJXc-display,
.mjx-math {
  font-size: 1em !important;
}

/* 确保行内公式和文字基线对齐 */
.katex,
mjx-container[display="false"] {
  line-height: inherit !important;
  vertical-align: baseline !important;
}

/* 块级/多行公式需要独立行盒，避免大分数与相邻行互相覆盖 */
.katex-display,
mjx-container[display="true"] {
  font-size: 1em !important;
  display: block !important;
  line-height: 1.5 !important;
  margin: 0.75em 0 !important;
  overflow: visible !important;
  text-align: inherit !important;
}

/* Quill 的对齐样式原本只在 .ql-editor 内生效；题库和文档展示态也要遵循。 */
.ql-align-center {
  text-align: center;
}

.ql-align-right {
  text-align: right;
}

.ql-align-justify {
  text-align: justify;
}

.ql-display-formula {
  display: block;
  width: 100%;
  margin: 0.75em 0;
  overflow: visible;
  text-align: inherit;
}
</style>
